<template>
  <path
    d="M20 4.00018H4C2.9 4.00018 2 4.90018 2 6.00018V18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V6.00018C22 4.90018 21.1 4.00018 20 4.00018ZM19.6 8.25018L13.06 12.3402C12.41 12.7502 11.59 12.7502 10.94 12.3402L4.4 8.25018C4.15 8.09018 4 7.82018 4 7.53018C4 6.86018 4.73 6.46018 5.3 6.81018L12 11.0002L18.7 6.81018C19.27 6.46018 20 6.86018 20 7.53018C20 7.82018 19.85 8.09018 19.6 8.25018Z"
  />
</template>
